import { useState, useEffect } from "react";
import '../Styles/NetworkStatus.css';

const NetworkStatus = () => {
    const [isOffline, setIsOffline] = useState(!navigator.onLine);
    const [showOnline, setShowOnline] = useState(false);

    useEffect(() => {
        const handleOnline = () => {
            setIsOffline(false);
            setShowOnline(true);
            setTimeout(() => setShowOnline(false), 2000);
        };

        const handleOffline = () => {
            setShowOnline(false);
            setIsOffline(true);
        };

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []);



    return (
        <>
            {isOffline && <div className="notification-container  offline slide-down">You are offline! 😥</div>}
            {showOnline && <div className="notification-container online slide-up">You are back online! 😍</div>}
        </>
    );
};

export default NetworkStatus;
